// import React, { useEffect } from 'react';
// import OrderCard from './card';
// import './style.scss';
// import { fetchReportData } from '../../services/fetchReportData';
// // import { FaShoppingCart, FaRocket, FaSyncAlt, FaCreditCard } from 'react-icons/fa';
// import {
//   File,
//   FileText,
//   FileCode,
//   FileSpreadsheet,
//   FileImage,
//   FileAudio,
//   FileVideo,
//   FileArchive,
//   FileJson,
//   FileSearch,
//   Loader,
//   ChartColumnIncreasing,
//   Check,
// } from "lucide-react";
// import { Link } from 'react-router-dom';
// import { CustomLoader } from '../../components/Loader';

// // const getRandomColor = () => {
// //   return colors[Math.floor(Math.random() * colors.length)];
// // };

// function App() {
//   const colors = ['#3b8efc', '#2ed8b6', '#fbc02d', '#ff6b81', '#ff7043', '#42a5f5', '#ab47bc'];

//   const userToken = localStorage.getItem("user_token");
//   const [loading, setLoading] = React.useState(false);
//   const [categoryData, setCategoryData] = React.useState([]);


//   const fileIcons = [
//     File,
//     FileText,
//     FileCode,
//     FileSpreadsheet,
//     FileImage,
//     FileAudio,
//     FileVideo,
//     FileArchive,
//     FileJson,
//     FileSearch,
//   ];
//   useEffect(() => {
//     const getData = async () => {
//       setLoading(true)
//       try {
//         const data = await fetchReportData(userToken);
//         setCategoryData(data?.message?.categories);
//         setLoading(false)
//       } catch (error) {
//         setLoading(false)
//         console.error('Error fetching report data:', error);
//       }
//     };

//     getData();
//   }, [userToken]);


//   const ReportCard = ({ title, time }) => {
//     const color = getColorClass(title);
//     return (
//       <div className={`card card-${color}`}>
//         <div className="card-header">
//           <span className={`icon icon-${color}`}>
//             <ChartColumnIncreasing style={{
//               // color:"white"
//             }} />
//           </span>
//           <h3>{title}</h3>
//         </div>
//         <div className="card-body">
//         <h2 className='report-header' >
//           <span className="report-icon"><FileText size={20} color="#007bff" /></span>
//           32 <span>Reports</span>
//         </h2>
//           <p>Active now:</p>
//           <ul className="report-list">
//           <li> User Engagement analysis</li>
//           <li>Monthly Sales Report</li>
//         </ul>
//         </div>
//         <div className="card-footer">
//           {/* <span>Last Opened: Apr 25, 2025 - {time}</span> */}
//           <button className={`btn btn-${color}`}>View Now</button>
//         </div>
//       </div>
//     );
//   };

//   const reportData = [
//     { title: 'Closing Stock', time: '09:00 AM' },
//     { title: 'B2B', time: '09:00 AM' },
//     { title: 'Transaction', time: '07:00 AM' },
//     { title: 'Sales', time: '08:00 AM' },
//     { title: 'Purchase', time: '08:00 AM' },
//     { title: 'Master', time: '09:00 AM' },
//   ];

//   const getColorClass = (title) => {
//     const map = {
//       'Closing Stock': 'blue',
//       'B2B': 'red',
//       'Transaction': 'purple',
//       'Sales': 'yellow',
//       'Purchase': 'green',
//       'Master': 'cyan',
//     };
//     return map[title] || 'blue';
//   };
//   return (
//     <div>
//       <div className="" style={{
//         padding: '10px',
//         fontFamily:"inherit"
//       }}>

//       <h2>Category List</h2>
//       </div>
//       {loading ?
//       <div style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '100vh',
//         backgroundColor: '#f0f0f0',
//         flexDirection: 'column'
//       }}>
//       <CustomLoader />
//       </div>
//        : <div className="report-cards">
//        {reportData.map((report, index) => (
//          <ReportCard key={index} {...report} />
//        ))}
//      </div>

//       //  <div className="card-container">
//       //   {categoryData?.map((card, index) => (
//       //     <Link to={`/dashboard/reports?categoryName=${card?.category}`} >
//       //       <OrderCard
//       //         key={index}
//       //         icon={React.createElement(fileIcons[index])}
//       //         name={card.category}
//       //         count={card.count}
//       //         bgColor={colors[index % colors.length]}
//       //       />
//       //     </Link>

//       //   ))}
//       // </div>
//       }
//     </div>
//   );
// }

// export default App;



import React, { useEffect } from "react";
import "./style.scss";
import { ChartColumnIncreasing, FileText } from "lucide-react";
import { fetchReportData } from '../../services/fetchReportData';
import { CustomLoader } from '../../components/Loader';
import { Link } from "react-router-dom";

const cards = [
  { title: "Closing Stock", color: "blue" },
  { title: "B2B", color: "red" },
  { title: "Transaction", color: "purple" },
  { title: "Sales", color: "orange" },
  { title: "Purchase", color: "green" },
  { title: "Master", color: "teal" },
];

let colors = ["blue", "red", "purple", "orange", "green", "teal"];

const ReportCards = () => {

  const userToken = localStorage.getItem("user_token");
  const [loading, setLoading] = React.useState(false);
  const [categoryData, setCategoryData] = React.useState([]);


  useEffect(() => {
    const getData = async () => {
      setLoading(true)
      try {
        const data = await fetchReportData(userToken);
        setCategoryData(data?.message?.categories);
        setLoading(false)
      } catch (error) {
        setLoading(false)
        console.error('Error fetching report data:', error);
      }
    };

    getData();
  }, [userToken]);

  console.log(categoryData, "categoryData");

  return (
    <div className="report-grid">
      {loading ?
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: '#f0f0f0',
          flexDirection: 'column'
        }}>
          <CustomLoader />
        </div>
        :
        categoryData?.length === 0 ? 
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '70vh',
          // backgroundColor: '#f0f0f0',
          flexDirection: 'column'
        }}>
          <p>No Data found</p>
        </div>:
        categoryData?.map((card, index) => (
          <div className={`report-card ${colors[index]}`} key={index}>
            <div className="header">
              <div className="icon-container">
                <ChartColumnIncreasing size={24} color="white" />
              </div>
              <h5>{card?.category}</h5>
            </div>
            <div className="report-count">
              <FileText size={20} className="icon-color" />
              <h2>{card?.count}</h2>
              <span>Reports</span>
            </div>

            <div className="active-now">Active now</div>
            <ul className="features">

              {card?.reports?.slice(0,2)?.map((report, idx) => (
                <li key={idx}>
                  <div className="success-badge">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="check-icon"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  {report}
                </li>
              ))}

              {/* <li>   <div className="success-badge">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="check-icon"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div> User Engagement analysis</li>
              <li>   <div className="success-badge">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="check-icon"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div> Monthly Sales Report</li> */}
            </ul>

            <div className="footer">
              {/* <div className="timestamp">
              <span>Last Opened</span>
              <span>Apr 25, 2025 - 09:00 AM</span>
            </div> */}
             <Link to={`/dashboard/reports?categoryName=${card?.category}`} >
              <button>View Now</button>
              </Link>
            </div>
          </div>
        ))}
    </div>
  );
};

export default ReportCards;
